import ServiceExec from '@/common/utils/ServiceExec'
import {forEach} from "lodash";

class MypageSvc extends ServiceExec {

  /**
   * 게시판 리스트 (매니저 APP - 공지 (boardType : 3), FAQ (boardType : 6 ), 1:1문의 (boardType : 7))
   *
   * @param params
   * @returns {Promise<any> | Q.Promise<any> | * | PromiseLike<any>}
   */
  getBoardList(params = {}) {
    const formData = new FormData()
    forEach(params, function (value, key) {
      formData.append(key, value)
    })
    return this.post(`/api/app/board/getBoardListData`, formData)
      .then(res => res.data)
  }

  /**
   * 게시판 상세 (공지, FAQ, 1:1문의)
   *
   * @param params
   * @returns {Promise<any> | Q.Promise<any> | * | PromiseLike<any>}
   */
  getBoardDetail(params = {}) {
    const formData = new FormData()
    forEach(params, function (value, key) {
      formData.append(key, value)
    })
    return this.post(`/api/app/board/getBoardDetail`, formData)
      .then(res => res.data)
  }

  /**
   * 1:1문의 등록
   *
   * @param params
   * @returns {Promise<any> | Q.Promise<any> | * | PromiseLike<any>}
   */
  saveInquire(params = {}) {
    const formData = new FormData()
    forEach(params, function (value, key) {
      formData.append(key, value)
    })
    return this.post(`/api/app/board/registInquire`, formData)
      .then(res => res.data)
  }

  /**
   * 1:1문의 삭제
   *
   * @param params
   * @returns {Promise<any> | Q.Promise<any> | * | PromiseLike<any>}
   */
  deleteInquire(params = {}) {
    const formData = new FormData()
    forEach(params, function (value, key) {
      formData.append(key, value)
    })
    return this.post(`/api/app/board/removeInquire`, formData)
      .then(res => res.data)
  }

  /**
   * 1:1문의 수정
   *
   * @param params
   * @returns {Promise<any> | Q.Promise<any> | * | PromiseLike<any>}
   */
  modifyInquire(params = {}) {
    const formData = new FormData()
    forEach(params, function (value, key) {
      formData.append(key, value)
    })
    return this.post(`/api/app/board/modifyInquire`, formData)
      .then(res => res.data)
  }

  getPushLogListData(params = {}) {
    return this.queryPost(`/api/app/account/getPushLogListData`, params)
      .then(res => res.data)
  }
}

export default new MypageSvc()
